export default __webpack_public_path__ + "static/media/SVGReports.635bcc1e.svg";